module.exports = __webpack_public_path__ + "assets/peoples.98db8323.svg";